module.exports = __webpack_public_path__ + "img/WechatIMG162.05ff8e69.jpeg";